module.exports = __webpack_public_path__ + "img/desktop_items_banner.e96888cd.png";